import { Radio, Space } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { WithDataFetcher } from '../../Data/WithDataFetcher';
import { FormContext } from '../FormEngine';
import { getHealthWellFundMedications } from '../SpecialRules/HealthWellSpecialRules';
import './RadioInputStyle.css';

const HealthWellFundMedications = props => {
    const { def, data, onChange, state } = props;
    const { getThenResolver } = props;
    const [fundMeds, setFundMeds] = useState(null);

    const ctx = useContext(FormContext);

    useEffect(() => {
        async function loadFundMeds() {
            const meds = await getHealthWellFundMedications(getThenResolver, ctx.meta.assistanceProgramId);
            setFundMeds(meds);
        };

        loadFundMeds();
    
    }, []);

    const selectedFund = ctx.formData['HealthWell Fund Applying For'];

    if (!fundMeds || !selectedFund) return null;

    return <Radio.Group
            value={data}
            onChange={(e) => { if (!state.readonly) onChange(def.dataKey, e.target.value) }}
            data-input={'healthwellfundmedicationsinput_de'}
        >
            <Space direction='vertical'>
                {fundMeds.find(f => f.fundName === selectedFund)?.medications.map(med => {
                    const label = med.name;
                    const val = med.value;

                    return <Radio value={val} style={{ color: 'black !important' }}>{label}</Radio>
                })}
            </Space>
        </Radio.Group>
}

export default WithDataFetcher(HealthWellFundMedications);
